import React, { useState } from 'react';
import useDesignerStore from './designerStore';
import DataBindingModal from './DataBindingModal';
import '../../styles/Buttons.css';
// import './Buttons.css';
import Icon from '../../components/Icon';
import { ICON_SM } from '../../components/iconSizes';
import ConditionalStyleEditor from './ConditionalStyleEditor';
import { toast } from 'react-toastify';
import { isMovableObject } from './designerLayout';




export default function LayerPanel() {
  const {
    bindingModal,
    openBindingModal,
    closeBindingModal,
    objects,
    selectedIds,
    setSelectedIds,
    bringForward,
    sendBackward,
    moveToTop,
    moveToBottom,
    updateObject,
    getSelectedObject,
    copySelected,
    pasteClipboard,
    selectedTemplateId,
    alignSelected,
    distributeSelectedHorizontal,
    distributeSelectedVertical,
    rotateSelected90,
    datasetId,
    datasetName,
    deleteObject,
    deleteSelected,
    cardSettings,
    activeSurface,
    copySelectedToSurface,
    isInteracting,
    commitSelectedObjectsFromStage,
    flushTransforms
  } = useDesignerStore();

  const getLayerLabel = (obj) => {
    if (obj.isBackground) return 'Background';

    const typeMap = {
      rect: 'Rectangle',
      circle: 'Circle',
      ellipse: 'Ellipse',
      polygon: 'Polygon',
      star: 'Star',
      line: 'Line',
      arrow: 'Arrow',
      image: 'Image',
      photo: 'Photo',
      text: 'Text',
      qrcode: 'QR Code'
    };

    const base = typeMap[obj.type] || obj.type;

    if (obj.dataBinding?.fieldKey) {

      const hasConditions =
        obj.dataBinding?.conditions &&
        obj.dataBinding.conditions.length > 0;

      return `${base} — ${obj.dataBinding.fieldKey}${hasConditions ? " ⚡" : ""}`;
    }

    return base;
  };




  const handleRightClick = (e, objId) => {
    e.preventDefault();

    if (!objId) return;

    console.log("activeSurface:", activeSurface)

    // 🔒 Block binding on silver surfaces
    if ((activeSurface === "frontSilver") || (activeSurface === "backSilver")) {
      console.warn('Binding disabled on silver surfaces');
      return;
    }

    // ensure selection matches intent
    setSelectedIds([objId]);

    openBindingModal(objId);
  };



  const canCopyToSilver =
    cardSettings.silverFront === 'yes' &&
    activeSurface === 'front' &&
    selectedIds.length > 0;

  const canCopyToBackSilver =
    activeSurface === 'back' &&
    cardSettings.sides === 'Duplex' &&
    cardSettings.silverBack === 'yes' &&
    selectedIds.length > 0;


    const isSilverSurface = (surface) =>
      surface === 'frontSilver' || surface === 'backSilver';

    const sObj = getSelectedObject();

    const showDensity =
      sObj &&
      isSilverSurface(activeSurface);



  const targetObj = bindingModal.targetId
    ? objects.find(o => o.id === bindingModal.targetId)
    : null;

  const handleBindSave = (binding) => {
    if (!bindingModal.targetId) return;
    // Persist binding onto the object
    updateObject(bindingModal.targetId, {
      dataBinding: {
        templateId: binding.templateId,
        fieldKey: binding.fieldKey
      }
    });
    // setBindingTargetId(null);
  };

  const selectedObj =
    selectedIds.length === 1
      ? objects.find(o => o.id === selectedIds[0])
      : null;

  const conditions =
    selectedObj?.dataBinding?.conditions || [];

    const selectedObject = objects.find(
      o => o.id === bindingModal.targetId
    );

    const currentBinding = selectedObject?.dataBinding || null;

    const isBgSelected = selectedObj?.isBackground === true;
    const movableSelectedCount = objects.filter(
      object => selectedIds.includes(object.id) && isMovableObject(object)
    ).length;
console.log("objects:", objects)

  return (
    <div className="layer-panel">

      {/* ── Fixed Header ───────────────── */}
      <div className="layer-panel-header">
        <h4>Object Panel</h4>

        {canCopyToSilver && !isBgSelected && (
          <button
            className="btn-white"
            onClick={() => {
              if (flushTransforms) {
                flushTransforms();
              }
              copySelectedToSurface('frontSilver');
              toast.success('Object copied to silver panel');
            }}
          >
            Copy → Silver
          </button>
        )}
        {canCopyToBackSilver && !isBgSelected && (
          <button
            className="btn-white"
            onClick={() => {
              if (flushTransforms) {
                flushTransforms();
              }
              copySelectedToSurface('backSilver')
              toast.success('Object copied to silver panel');
          }}
          >
            Copy → Back Silver
          </button>
        )}
        {showDensity && (
          <div className="layer-control">
            <label style={{ fontSize: '0.75rem' }}>
              Silver Density
            </label>

            <input
              type="range"
              min="0.2"
              max="1"
              step="0.05"
              value={selectedObj.density ?? 1.0}
              onChange={(e) => {
                updateObject(selectedObj.id, {
                  density: parseFloat(e.target.value)
                });
              }}
            />

            <div style={{
              fontSize: '0.7rem',
              opacity: 0.7,
              textAlign: 'right'
            }}>
              {(selectedObj.density ?? 1.0).toFixed(2)}
            </div>
          </div>
        )}

        <span style={{fontSize:".7rem"}}>Right click object to assign template field.</span>
        {/* Order controls */}
        <div className="layout-controls-label">Layout</div>
        <div className="layer-move-buttons">
          <button title="Bring Forward" onClick={bringForward}>
            <Icon name="arrow-up" size={ICON_SM} />
          </button>

          <button title="Send Backward" onClick={sendBackward}>
            <Icon name="arrow-down" size={ICON_SM} />
          </button>

          <button title="Move to Top" onClick={moveToTop}>
            <Icon name="angle-double-up" size={ICON_SM} />
          </button>

          <button title="Move to Bottom" onClick={moveToBottom}>
            <Icon name="angle-double-down" size={ICON_SM} />
          </button>
        </div>

        <div className="layer-move-buttons" aria-label="Layout alignment and distribution">
          <button
            title="Duplicate selected"
            disabled={isBgSelected}
            onClick={() => {
              if (selectedIds.length === 0) return;
              copySelected();
              pasteClipboard();
            }}
          >
            <Icon name="copy" size={ICON_SM} />
          </button>

          <button
            title="Align Left"
            aria-label="Align Left"
            onClick={() => alignSelected('left')}
            disabled={movableSelectedCount < 2}
          >
            <Icon name="align-left" size={ICON_SM} />
          </button>

          <button
            title="Align Horizontal Center"
            aria-label="Align Horizontal Center"
            onClick={() => alignSelected('center')}
            disabled={movableSelectedCount < 2}
          >
            <Icon name="align-center" size={ICON_SM} />
          </button>

          <button
            title="Align Right"
            aria-label="Align Right"
            onClick={() => alignSelected('right')}
            disabled={movableSelectedCount < 2}
          >
            <Icon name="align-right" size={ICON_SM} />
          </button>

          <button
            title="Align Top"
            aria-label="Align Top"
            onClick={() => alignSelected('top')}
            disabled={movableSelectedCount < 2}
          >
            <Icon name="vertical-align-top" size={ICON_SM} />
          </button>

          <button
            title="Align Vertical Middle"
            aria-label="Align Vertical Middle"
            onClick={() => alignSelected('middle')}
            disabled={movableSelectedCount < 2}
          >
            <Icon name="align-center-v" size={ICON_SM} />
          </button>

          <button
            title="Align Bottom"
            aria-label="Align Bottom"
            onClick={() => alignSelected('bottom')}
            disabled={movableSelectedCount < 2}
          >
            <Icon name="vertical-align-bottom" size={ICON_SM} />
          </button>

          <button
            title="Distribute Horizontally"
            aria-label="Distribute Horizontally"
            onClick={distributeSelectedHorizontal}
            disabled={movableSelectedCount < 3}
          >
            <Icon name="arrows-resize-h" size={ICON_SM} />
          </button>

          <button
            title="Distribute Vertically"
            aria-label="Distribute Vertically"
            onClick={distributeSelectedVertical}
            disabled={movableSelectedCount < 3}
          >
            <Icon name="arrows-resize-v" size={ICON_SM} />
          </button>

          <button
            title="Rotate 90°"
            onClick={rotateSelected90}
            disabled={(selectedIds.length === 0) || isBgSelected}
          >
            <Icon name="redo" size={ICON_SM} />
          </button>
        </div>
      </div>


      {/* ── Scrollable List ────────────── */}
      <div className="layer-list">
        <span style={{fontSize:".6rem", fontWeight:"bold", paddingLeft:"20px"}}> Bottom of Card </span>
        {objects.map((obj, index) => {
          const isBound = Boolean(obj.dataBinding?.fieldKey);

          return (
          <div
            key={obj.id}
            className={`layer-item ${selectedIds.includes(obj.id) ? 'selected' : ''}`}
            onClick={() => setSelectedIds([obj.id])}
            onContextMenu={(e) => handleRightClick(e, obj.id)}
            title="Right-click to bind to a Data Set → Template field"
          >
          <span className="layer-name">
            {getLayerLabel(obj).split(' — ')[0]}
            {obj.dataBinding?.fieldKey && (
              <span className="layer-binding">
                {' — '}
                {obj.dataBinding.fieldKey}
              </span>
            )}
          </span>

            <button
              className="layer-delete"
              title="Delete selected layer(s)"
              onClick={(e) => {
                e.stopPropagation(); // ⛔ do not trigger row click
                if (!selectedIds.includes(obj.id)) {
                  setSelectedIds([obj.id]); // ensure selection matches intent
                }
                deleteSelected();
              }}
              onContextMenu={(e) => {
                e.preventDefault(); // ⛔ disable right-click
                e.stopPropagation();
              }}
            >
              ✕
            </button>
          </div>
        )
      })}
      <span style={{fontSize:".6rem", fontWeight:"bold", paddingLeft:"20px"}}> Top of Card </span>
    </div>
    {!isBgSelected && <DataBindingModal
        show={bindingModal.open}
        templateId={selectedTemplateId}
        binding={
          objects.find(o => o.id === bindingModal.targetId)?.dataBinding || null
        }
        onClose={() => {
          closeBindingModal();
        }}
        onSave={(binding) => {
          if (!binding) {
            updateObject(bindingModal.targetId, {
              dataBinding: null
            });
          } else {
            updateObject(bindingModal.targetId, {
              dataBinding: {
                templateId: binding.templateId,
                fieldKey: binding.fieldKey
              }
            });
          }
        }}>
        {currentBinding && (
          <div className="binding-phase-2">
            <hr />
            <span className="condLabel">Conditional Styling</span><br/>
            <span style={{fontSize:".7rem"}}>  Adding conditions will allow the field value to control it's own color and background styling.</span>

            <ConditionalStyleEditor
              conditions={currentBinding.conditions || []}
              onChange={(nextConditions) => {
                updateObject(bindingModal.targetId, {
                  dataBinding: {
                    ...currentBinding,
                    conditions: nextConditions
                  }
                });
              }}
            />
          </div>
        )}
      </DataBindingModal>}
    </div>
  );
}
